export default theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(2)
  },
  textfield: {
    width: "100%"
  },
  toolbar: {
    margin: "4px"
  },
  bigAvatar: {
    width: 100,
    height: 100,
    margin: "auto"
  },
  buttonWrapper: {
    display: "flex",
    justifyContent: "space-between",
    margin: theme.spacing(2, 0, 2, 0)
  },
  switch: {
    // width: "100px",
    display: "flex",
    alignContent: "center",
    marginLeft: "auto",
    order: 3,
    [theme.breakpoints.up("sm")]: {
      order: 0
    }
  },
  sliderText: {
    margin: "auto 0",
    paddingLeft: "27px !important"
  },
  formControl: {
    minWidth: 200
  },
  dropdown: {
    padding: "10px 31px 10px 12px"
  },
  fieldError: {
    color: theme.palette.danger.main,
    marginTop: theme.spacing(1)
  },
  submitError: {
    color: theme.palette.danger.main,
    alignText: "center",
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2)
  },
  progress: {
    display: "block",
    marginTop: theme.spacing(2),
    marginLeft: "auto",
    marginRight: "auto"
  },
  saveButton: {
    marginTop: theme.spacing(2)
  },
  imgPreview: {
    marginLeft: theme.spacing(1),
    borderRadius: "3px",
    width: "53px",
    height: "53px"
  },
  tabRoot: {
    backgroundColor: theme.palette.background.light
  },
  colorLabelRoot: {
    display: "flex",
    alignItems: "center"
  },
  colorLabel: {
    minWidth: "160px"
  },
  colorRoot: {
    display: "flex"
  },
  chatCircle: {
    background: "#fff",
    boxShadow: "0 0 10px -2px #d2d2d2",
    height: 70,
    width: 70,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 15,
    marginTop: -5
  },
  chatCircleIcon: {
    width: "90%", 
    height: "auto"
  }
});
